import { render, staticRenderFns } from "./PraticaMareExtension.vue?vue&type=template&id=1a5087bb&"
import script from "./PraticaMareExtension.vue?vue&type=script&lang=js&"
export * from "./PraticaMareExtension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a5087bb')) {
      api.createRecord('1a5087bb', component.options)
    } else {
      api.reload('1a5087bb', component.options)
    }
    module.hot.accept("./PraticaMareExtension.vue?vue&type=template&id=1a5087bb&", function () {
      api.rerender('1a5087bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/PraticaMareExtension.vue"
export default component.exports